import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import {
  identifierSaveStore,
  permissionStore,
  projectApiStore,
  projectStore,
} from "@/hooks";
import { FlexBox, TextButton, Separator } from "@/components/common";


/**
 * Displays buttons for interacting with projects.
 */
const __default__ = {
  name: "ProjectButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const displayEditing = computed(() =>
  permissionStore.isAllowed("project.edit")
);
const displayDeleting = computed(() =>
  permissionStore.isAllowed("project.delete")
);

/**
 * Opens the edit modal.
 */
function handleEdit(): void {
  identifierSaveStore.selectIdentifier(projectStore.project, "edit");
}

/**
 * Opens the edit modal.
 */
function handleDelete(): void {
  identifierSaveStore.selectIdentifier(projectStore.project, "delete");
}

/**
 * Opens the transfer modal.
 */
function handleTransfer(): void {
  identifierSaveStore.selectIdentifier(projectStore.project, "transfer");
}

/**
 * Downloads project files
 */
function handleDownload(fileType: "csv" | "json" = "csv"): void {
  projectApiStore.handleDownload(fileType);
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_unref(FlexBox), {
    wrap: "",
    t: "2",
    class: "settings-buttons"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_btn_group, { flat: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            label: "Download",
            icon: "download",
            "data-cy": "button-settings-download",
            onClick: handleDownload
          }),
          _createVNode(_component_q_btn_dropdown, {
            "auto-close": "",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), {
                text: "",
                label: "CSV",
                onClick: handleDownload
              }),
              _createVNode(_unref(TextButton), {
                text: "",
                label: "JSON",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownload('json')))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (displayEditing.value)
        ? (_openBlock(), _createBlock(_unref(Separator), {
            key: 0,
            vertical: ""
          }))
        : _createCommentVNode("", true),
      (displayEditing.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 1,
            text: "",
            label: "Edit",
            icon: "edit",
            "data-cy": "button-settings-edit",
            onClick: handleEdit
          }))
        : _createCommentVNode("", true),
      (displayDeleting.value)
        ? (_openBlock(), _createBlock(_unref(Separator), {
            key: 2,
            vertical: ""
          }))
        : _createCommentVNode("", true),
      (displayDeleting.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 3,
            text: "",
            label: "Transfer",
            icon: "forward",
            "data-cy": "button-settings-transfer",
            onClick: handleTransfer
          }))
        : _createCommentVNode("", true),
      (displayDeleting.value)
        ? (_openBlock(), _createBlock(_unref(Separator), {
            key: 4,
            vertical: ""
          }))
        : _createCommentVNode("", true),
      (displayDeleting.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 5,
            text: "",
            label: "Delete",
            icon: "delete",
            "data-cy": "button-settings-delete",
            onClick: handleDelete
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})